var angular = require('angular');
var ngModule = angular.module('/navigation/views/navigation.html', []);
ngModule.run(['$templateCache', function($templateCache) {
  $templateCache.put('/navigation/views/navigation.html',
    '<ul>\n' +
    '    <li><a ui-sref-active="active" ui-sref="wheel">{{ \'WHEEL\' | translate }}</a></li>\n' +
    '    <li><a ui-sref-active="active" ui-sref="participants">{{ \'PARTICIPANTS\' | translate }}</a></li>\n' +
    '    <li><a ui-sref-active="active" ui-sref="winners">{{ \'WINNERS\' | translate }}</a></li>\n' +
    '</ul>\n' +
    '');
}]);

module.exports = "/navigation/views/navigation.html";